/**
 * Class Name Utility
 * Module 07 - Dashboard UI
 * 
 * Combines and merges Tailwind CSS class names intelligently
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine and merge class names with Tailwind-aware deduplication
 * 
 * @param inputs - Class names to combine
 * @returns Merged class name string
 * 
 * @example
 * cn('text-red-500', 'text-blue-500') // 'text-blue-500' (later class wins)
 * cn('px-4 py-2', className) // Merges with external className prop
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
